<div class="fixed transform z-1" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>

<ng-container *ngIf="!createScreenBool">
  <div class="bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg title-case" style="min-height: 50px;">
      <div class="conten clean-small" style="margin-top: -3px;">
        <div class="btn"><a>Users</a></div>
      </div>
      <div class="flex justify-content-end mb-1">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchField" (input)="applyFilterGlobal($event, 'contains')"
          placeholder="Search..." />
          <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool" (click)="clearSearchField()"></i>
        </span>
      </div>
    </div>
      <div class="grid flex justify-content-end mt-2">
        <div class="col-12 md:col-4 lg:col-2" *ngIf="!RoleName.toLowerCase().includes('facility')">     
          <label><b>System</b></label>      
          <span class="p-input-icon-right w-full">
            <p-multiSelect class="w-full" (click)="GetAllData('system')" (onChange)="GetFacility()" [options]="systemList" [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}"
              placeholder="-- Select --" defaultLabel="--Select--" display="chip"  [(ngModel)]="selectedSystem" 
              optionLabel="Text" optionValue="Value" virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
            </p-multiSelect>
          </span>
        </div>
        <div class="col-12 md:col-4 lg:col-2" >
          <label><b>Facility</b></label>           
          <span class="p-input-icon-right w-full">
            <p-multiSelect class="w-full" (click)="GetAllData('facility')" [options]="facilityList" [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}"
              placeholder="-- Select --" defaultLabel="--Select--" display="chip"  [(ngModel)]="selectedFacility" (onChange)="OnMultiSelectChange()"
              optionLabel="Text" optionValue="Value" virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
            </p-multiSelect>
          </span>
        </div>
        <div class="col-12 md:col-4 lg:col-2" >     
          <label><b>TeleCare User Type</b></label>      
          <span class="p-input-icon-right w-full">
            <p-multiSelect class="w-full" (click)="GetRolesAndStates()" [options]="rolesList" [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}"
              placeholder="-- Select --" defaultLabel="--Select--" display="chip"  [(ngModel)]="selectedUserType" (onChange)="OnMultiSelectChange()"
               optionLabel="RoleName" optionValue="RoleId" virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
            </p-multiSelect>
          </span>
        </div>
      </div>   
      <div class="grid flex justify-content-end mb-2 mt-2">
        <span>
          <p-button label=" Export to Excel" icon="pi pi-upload"
                (click)="exportExcel()" [loading]="exportExcelLoader" class="p-button-primary"></p-button>
          <p-button *ngIf="isAccessReadWrite && !roleForFacility" class="ml-2 mr-2 w-full p-button-primary" type="button" icon="pi pi-plus"
          label="Add User" (click)="addUser()"></p-button>
        </span>      
    </div>
      <p-table #dt [value]="usersList" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines overflow-x-auto"
        [paginator]="true" sortMode="multiple"[lazy]="true" (onLazyLoad)="lazyLoadSchedules($event)" [resizableColumns]="true" columnResizeMode="expand"
        responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
        styleClass="p-datatable-striped p-datatable-gridlines overflow-x-auto"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]"
        [globalFilterFields]="['UserName','FirstName','LastName','RoleName','Initials','UserLoginTime','IsActive']" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="UserName" pResizableColumn>Username
              <p-sortIcon field="UserName"></p-sortIcon>
            </th>
            <th pSortableColumn="FirstName" pResizableColumn>First Name
              <p-sortIcon field="FirstName"></p-sortIcon>
            </th>
            <th pSortableColumn="LastName"  pResizableColumn>Last Name
              <p-sortIcon field="LastName"></p-sortIcon>
            </th>
            <th pSortableColumn="PhoneNumber" pResizableColumn>Phone
              <p-sortIcon field="PhoneNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="Email" pResizableColumn>Email
              <p-sortIcon field="Email"></p-sortIcon>
            </th>
            <th pSortableColumn="RoleName" pResizableColumn>TeleCare User Type
              <p-sortIcon field="RoleName"></p-sortIcon>
            </th>
            <th pSortableColumn="Initials" pResizableColumn>Initials
              <p-sortIcon field="Initials"></p-sortIcon>
            </th>
            <th pSortableColumn="UserLoginTime" pResizableColumn>Last Login Time
              <p-sortIcon field="UserLoginTime"></p-sortIcon>
            </th>
            <th pSortableColumn="IsActive" pResizableColumn>Active
              <p-sortIcon field="IsActive"></p-sortIcon>
            </th>
            <th>Action </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-usersList>
          <tr>
            <td>
              {{usersList.UserName}}
            </td>
            <td>
              {{usersList.FirstName}}
            </td>
            <td>
              {{usersList.LastName}}
            </td>
            <td>
              {{usersList.MobilePhone}}
            </td>
            <td>
              {{usersList.Email}}
            </td>
            <td>
              {{usersList.RoleName}}
            </td>
            <td>
              {{usersList.UserInitial}}
            </td>
            <td>
              {{usersList.UserLoginTime | date:"yyyy-MM-dd hh:mm:ss"}}
            </td>
            <td>
              <p-checkbox [(ngModel)]="usersList.IsActive" [binary]="true" [disabled]="true"></p-checkbox>
            </td>
            <td>
              <a class="no-underline" (contextmenu)="onContextMenu($event,usersList.Id,'Edit')">
              <button  *ngIf="(isAccessReadWrite && !isAccessRead && !roleForFacility)" pButton pRipple icon="pi pi-pencil" pTooltip="Edit" tooltipPosition="left"
                class="p-button-rounded  p-button-primary"
                (click)="removeUserProfileCheck();GetUserDetailById(usersList.Id);onContextMenuPreventDefault($event)"></button>
              </a>
              <a class="no-underline" (contextmenu)="onContextMenu($event,usersList.Id,'View')">
                <button  pButton pRipple icon="pi pi-eye" *ngIf="(!isAccessReadWrite && isAccessRead || roleForFacility)"
                pTooltip="View User" tooltipPosition="bottom" class="p-button-rounded  p-button-primary"
                (click)="removeUserProfileCheck();GetUserDetailById(usersList.Id);onContextMenuPreventDefault($event)"></button>
              </a>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <h5 *ngIf="totalRecords==0" class="text-center create-roles">
              <b> No records found</b>
            </h5>
          </tr>
        </ng-template>
      </p-table>
      <div class="md:col-12">
        <span class="tableRefreshTime">
          Grid Last Refreshed at {{PiTeamService._currentDate}} - {{PiTeamService._currentTime}}
        </span>
      </div>
  </div>
</ng-container>
<ng-container *ngIf="createScreenBool">
  <div class="bg-default px-3 pb-3 content-height">
    <div class="flex align-items-center title-bg title-case">
      <ng-container *ngIf="buttonText == 'Update'">
        <div class="backbtn-measure cursor-pointer" (click)="onConfirm();" pTooltip="Back" tooltipPosition="right">
          <i class="pi pi-arrow-left"></i>
        </div>
      </ng-container>

      <div class="conten">
        <div class="btn" *ngIf="buttonText == 'Save'"><a> Create New User</a></div>
        <div class="btn" *ngIf="buttonText == 'Update' && !isAccessRead "><a> {{crateUserHeading}}</a></div>
        <div class="btn" *ngIf="buttonText == 'Update' && isAccessRead"><a> View User</a></div>
      </div>
    </div>

    <div >
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div [ngStyle]="(isAccessRead || roleForFacility) && !profileCheckBoxBool ?{'pointer-events': 'none'} : {'pointer-events': 'all'}" class="formgrid grid mt-3">
          <div></div>
          <div class="field col-12 md:col-4">
            <label for="FirstName"><b>First Name:</b><span
                [ngClass]="f['FirstName'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                *</span></label>
            <span class="p-input-icon-right w-full"
              [ngStyle]="disableEditProfile || isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
              <input id="FirstName" name="FirstName" type="text" class="inputfield w-full" pInputText
                formControlName="FirstName">
            </span>
            <div *ngIf="f['FirstName'].errors && (f['FirstName'].touched || f['FirstName'].dirty)"
              class="invalid-feedback">
              <div *ngIf="f['FirstName'].errors['required']"><b>First Name is required</b></div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="LastName"><b>Last Name:</b><span
                [ngClass]="f['LastName'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                *</span></label>
            <span class="p-input-icon-right w-full"
              [ngStyle]="disableEditProfile || isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
              <input id="LastName" name="LastName" type="text" class="inputfield w-full" pInputText
                formControlName="LastName">
            </span>
            <div *ngIf="f['LastName'].errors && (f['LastName'].touched || f['LastName'].dirty)"
              class="invalid-feedback">
              <div *ngIf="f['LastName'].errors['required']"><b>Last Name is required</b></div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="UserInitial"><b>Initials:</b></label>
            <span class="p-input-icon-right w-full"
              [ngStyle]="disableEditProfile || isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
              <input id="UserInitial" name="UserInitial" type="text" class="inputfield w-full" pInputText
                formControlName="UserInitial">
            </span>
            <div *ngIf="f['UserInitial'].errors && (f['UserInitial'].touched || f['UserInitial'].dirty)"
              class="invalid-feedback">
              <div *ngIf="f['UserInitial'].errors || f['maxlength']"><b>The field UserInitial must be a string
                with a maximum length of 6</b></div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="UserName"><b>Username:</b><span
                [ngClass]="f['UserName'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                *</span></label>
            <span class="p-input-icon-right w-full"
              [ngStyle]="disableEditProfile || isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
              <input id="UserName" name="UserName" type="text" class="inputfield w-full" pInputText
                formControlName="UserName">
            </span>
            <div *ngIf="f['UserName'].errors && (f['UserName'].touched || f['UserName'].dirty)"
              class="invalid-feedback">
              <div *ngIf="f['UserName'].errors['required']"><b>Username is required</b></div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <ng-container>
              <label *ngIf="!invalidEmailBool" for="Email"><b>Email:</b><span
                  [ngClass]="f['Email'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                  *</span></label>
            </ng-container>
            <ng-container>
              <label *ngIf="invalidEmailBool" for="Email"><b>Email:</b><span Class="invalid-feedback">
                  *</span></label>
            </ng-container>
            <span class="p-input-icon-right w-full">
              <input (focusout)="ValidateEmail();" id="Email" name="Email" type="email" class="inputfield w-full"
                pInputText formControlName="Email">
            </span>
            <div *ngIf="f['Email'].errors && (f['Email'].touched || f['Email'].dirty)" class="invalid-feedback">
              <div *ngIf="f['Email'].errors['required']"><b>Email is required</b></div>
              <!-- <div *ngIf="f['Email'].errors['email']">Invalid Email Format</div> -->
            </div>
            <p *ngIf="invalidEmailBool" style="color:red;font-weight: bold;margin: 0px;"><b>Invalid Email Format</b></p>
          </div>
          <ng-container *ngIf="buttonText == 'Save'">
            <div class="field col-12 md:col-4">
              <label for="Password"><b>Password:</b><span
                  [ngClass]="f['Password'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                  *</span></label>
              <span class="p-input-icon-right w-full">
                <p-password formControlName="Password" (focusout)="passwordMatch();">
                  <ng-template pTemplate="footer">
                    <p-divider></p-divider>
                    <p class="mt-2">Password pattern required :</p>
                    <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                      <li>At least one lowercase</li>
                      <li>At least one uppercase</li>
                      <li>At least one numeric</li>
                      <li>At least one specail character</li>
                      <li>Minimum 8 characters</li>
                    </ul>
                  </ng-template>
                </p-password>
              </span>
              <div *ngIf="f['Password'].errors && (f['Password'].touched || f['Password'].dirty)"
                class="invalid-feedback">
                <div *ngIf="f['Password'].errors['required']"><b>Password is required</b></div>
                <div *ngIf="f['Password'].errors['pattern']"><b>Invalid password pattern</b></div>
              </div>
            </div>
            <div class="field col-12 md:col-4">
              <label for="ConfirmPassword"><b>Confirm Password::</b><span
                  [ngClass]="f['ConfirmPassword'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                  *</span></label>
              <span class="p-input-icon-right w-full">
                <input id="ConfirmPassword" name="ConfirmPassword" type="password" class="inputfield w-full" pInputText
                  formControlName="ConfirmPassword" (focusout)="passwordMatch()">
              </span>
              <p *ngIf="comfirmPasswordMatchBool" class="invalid-feedback"><b>The password and confirmation password do not
                match.</b></p>
              <div *ngIf="f['ConfirmPassword'].errors && (f['ConfirmPassword'].touched || f['ConfirmPassword'].dirty)"
                class="invalid-feedback">
                <div *ngIf="f['ConfirmPassword'].errors['required']"><b>Confirm Password is required</b></div>
              </div>
            </div>
          </ng-container>
          <div class="field col-12 md:col-4">
            <label for="MobilePhone"><b>Mobile Phone:</b><span
                [ngClass]="f['MobilePhone'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                *</span></label>
            <span class="p-input-icon-right w-full">
              <p-inputMask class="w-full" name="MobilePhone" mask="(999) 999-9999" formControlName="MobilePhone"
                placeholder="(999) 999-9999" class="inputfield w-full">
              </p-inputMask>
            </span>
            <div *ngIf="f['MobilePhone'].errors && (f['MobilePhone'].touched || f['MobilePhone'].dirty)"
              class="invalid-feedback">
              <div *ngIf="f['MobilePhone'].errors['required']"><b>Mobile Phone is required</b></div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="OtherPhone"><b>Other Phone:</b></label>
            <span class="p-input-icon-right w-full">
              <p-inputMask class="w-full" name="OtherPhone" mask="(999) 999-9999" formControlName="OtherPhone"
                placeholder="(999) 999-9999" class="inputfield w-full">
              </p-inputMask>
            </span>
          </div>
          <div class="field col-12 md:col-4">
            <label for="State_key"><b>TeleCare User Type:</b><span
                [ngClass]="f['RoleId'].errors  ? 'invalid-feedback' : 'valid-feedback'">
                *</span></label>
            <span class="p-input-icon-right w-full"
              [ngStyle]="disableEditProfile || isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
              <p-multiSelect (click)="GetRolesAndStates()" [options]="rolesList" formControlName="RoleId" placeholder="Select TeleCare User Type"
                defaultLabel="Select User Type" optionLabel="RoleName" display="chip" optionValue="RoleId">
              </p-multiSelect>
            </span>
            <div *ngIf="f['RoleId'].errors && (f['RoleId'].touched || f['RoleId'].dirty)" class="invalid-feedback">
              <div *ngIf="f['RoleId'].errors['required']"><b>TeleCare User Type is required</b></div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="NPINumber:"><b>NPI Number:</b></label>
            <span class="p-input-icon-right w-full"
              [ngStyle]="disableEditProfile || isAccessRead || roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
              <input id="NPINumber" name="NPINumber" type="text" class="inputfield w-full" pInputText [maxLength]="10"
                formControlName="NPINumber">
            </span>
            <div *ngIf="f['NPINumber'].errors && (f['NPINumber'].touched || f['NPINumber'].dirty)"
              class="invalid-feedback">
              <div *ngIf="f['NPINumber'].errors || f['NPINumber']">NPI Number should be 10 digits</div>
              <div *ngIf="f['NPINumber'].errors && f['minLength']">Invalid NPI Number</div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="Address_line1"><b>Address line 1:</b></label>
            <span class="p-input-icon-right w-full">
              <input id="Address_line1" name="Address_line1" type="text" class="inputfield w-full" pInputText
                formControlName="Address_line1">
            </span>
          </div>
          <div class="field col-12 md:col-4">
            <label for="Address_line2"><b>Address line 2:</b></label>
            <span class="p-input-icon-right w-full">
              <input id="Address_line2" name="Address_line2" type="text" class="inputfield w-full" pInputText
                formControlName="Address_line2">
            </span>
          </div>
          <div class="field col-12 md:col-4">
            <label for="City"><b>City:</b></label>
            <span class="p-input-icon-right w-full">
              <input id="City" name="city" type="text" class="inputfield w-full" pInputText formControlName="City">
            </span>
          </div>
          <div class="field col-12 md:col-4">
            <label for="State_key"><b>State:</b></label>
            <span class="p-input-icon-right w-full">
              <p-dropdown (click)="GetRolesAndStates()" class="w-full" placeholder="Select State" [options]="States" formControlName="State_key"
                optionValue="StateKey" [filter]="true" optionLabel="StateTitle"></p-dropdown>
            </span>
          </div>
          <div class="field col-12 md:col-4">
            <label for="Zip"><b>ZIP/Postal Code:</b></label>
            <span class="p-input-icon-right w-full">
              <input id="Zip" name="Zip" type="text" class="inputfield w-full" pInputText formControlName="Zip">
            </span>
          </div>
          <!-- -------------------------------- -->
          <div class="field col-12 md:col-4">
            <div *ngIf="UploadbtnDisplay">
              <label for="Zip"><b>Profile Image:</b></label>
              <div class="circle" *ngIf="imageUrlToShow">
                <img [src]="imageUrlToShow" class="Image">
              </div>
              <input id="file" type="file" (change)="onProfileImageChange($event)" accept="image/*"
                style="display: none;" />
              <label for="file" class="Img"><i class="pi pi-images mr-2"></i>Upload</label><br><br>
              <div *ngIf="invalidUploadfile" class="invalid-feedback">Invalid File,Allow only .jpeg, .jpg and png file
              </div>
            </div>
          </div>
        </div>
          <!-- -------------------------------- -->
          <div [ngStyle]="(isAccessRead) || (roleForFacility)?{'pointer-events': 'none'} : {'pointer-events': 'all'}" class="formgrid grid check-box md:col-12"  >
            <div class="field col-12 md:col-12">
              <p-checkbox formControlName="TwoFactorEnabled" [binary]="true"></p-checkbox>
              <label class="-mb-3 ml-3" for="TwoFactorEnabled"><b>Two Factor Enabled:</b></label>
            </div>
            <div class="field col-12 md:col-12">
              <p-checkbox formControlName="EnableFive9" [binary]="true"></p-checkbox>
              <label class="-mb-3 ml-3" for="EnableFive9"><b>Enable Five9:</b></label>
            </div>
            <div class="field col-12 md:col-12">
              <p-checkbox formControlName="CaseReviewer" [binary]="true"></p-checkbox>
              <label class="-mb-3 ml-3" for="CaseReviewer"><b>Case Reviewer:</b></label>
            </div>
            <div class="field col-12 md:col-12">
              <p-checkbox formControlName="IsActive" [binary]="true"></p-checkbox>
              <label class="-mb-3 ml-3" for="IsActive"><b>Active:</b></label>
            </div>
          </div>
        <div *ngIf="!isAccessRead" class="formgrid flex m-2">
          <div class="col-12 md:col-12 text-right mt-5">
            <ng-container *ngIf="!disableEditProfile">
                <button pButton type="button" (click)="backToSuperAdmin()" class=" btn-UnCancelCase">
                  <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
            </ng-container>
            <ng-container *ngIf="!invalidEmailBool">
              <p-button 
              [ngStyle]="(form.invalid && disabledButton) ? {'pointer-events': 'none'} : {'pointer-events': 'all'}"
                *ngIf="buttonText == 'Save'" class="ml-2 p-button-primary btn-padding-custom" type="button"
                [disabled]="form.invalid" (click)="submit()" [loading]="loading[0]" icon="pi pi-save"
                label="{{buttonText}}"></p-button>
            </ng-container>
            <ng-container *ngIf="invalidEmailBool">
              <p-button
              [ngStyle]="(invalidEmailBool) ? {'pointer-events': 'none'} : {'pointer-events': 'all'}" *ngIf="buttonText == 'Save'" class="ml-2 p-button-primary btn-padding-custom" type="button"
                [disabled]="true" (click)="submit()" [loading]="loading[1]" icon="pi pi-save" label="{{buttonText}}">
              </p-button>
            </ng-container>
            <ng-container *ngIf="!invalidEmailBool">
              <p-button *ngIf="(buttonText == 'Update' && !roleForFacility) || (buttonText == 'Update' && profileCheckBoxBool)" label="{{buttonText}}" icon="pi pi-save"
                [ngStyle]="(form.invalid && disabledButton) ?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                [disabled]="form.invalid" class="ml-2 p-button-primary btn-padding-custom" type="button"
                (click)="updateUserApiHit()" [loading]="loading[2]"></p-button>
            </ng-container>
            <ng-container *ngIf="invalidEmailBool">
              <p-button *ngIf="(buttonText == 'Update' && !roleForFacility) || (buttonText == 'Update' && profileCheckBoxBool)" label="{{buttonText}}" icon="pi pi-save" [disabled]="true"
              [ngStyle]="true?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                class="ml-2 p-button-primary btn-padding-custom" type="button" (click)="updateUserApiHit()"
                [loading]="loading[3]"></p-button>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- Toaster to move to previous form -->
<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid justify-content-center">
          <p-button label="YES" class="mr-2 p-button-primary btn-padding-custom update-cancle" (click)="onConfirm()" type="button">
          </p-button>
          <p-button label="NO" class="mr-2 p-button-primary btn-padding-custom update-cancle" (click)="onReject()" type="button">
          </p-button>
      </div>
    </div>
  </ng-template>
</p-toast>
